export const router_mantenimiento_previas = [
    {
        path: 'previas/lista',
        name: 'Previas list',
        component: () => import('./lista')
    }, {
        path: 'previas/consultar/:id',
        name: 'Previas consultar',
        component: () => import('./consultar')
    }, {
        path: 'previas/actualizar/nueva',
        name: 'Previa nueva',
        component: () => import('./actualizar')
    },
    {
        path: 'previas/actualizar/:id',
        name: 'Previas actualizar',
        component: () => import('./actualizar')
    },
]